import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';

import type { ArbitroWorkspaceState } from '../../types';
import type { PendenciasPublicacaoState } from '../../types/pendenciasPublicacaoTypes';
import { listarPendenciasPublicacao } from './actions';

export const pendenciasPublicacaoInitialState: PendenciasPublicacaoState = {
  items: [],
  pagination: { page: 0, limit: 20, total: 0, totalPages: 0 },
  processoId: null,
  requestId: null,
  loading: false,
  error: null,
};

export function addPendenciasPublicacaoReducers(
  builder: ActionReducerMapBuilder<ArbitroWorkspaceState>,
): void {
  builder
    .addCase(listarPendenciasPublicacao.pending, (state, action) => {
      const { id, page = 1 } = action.meta.arg;
      if (page === 1)
        state.pendenciasPublicacao = { ...pendenciasPublicacaoInitialState, processoId: id };
      const atual = state.pendenciasPublicacao;
      atual.requestId = action.meta.requestId;
      atual.loading = true;
      atual.error = null;
    })
    .addCase(listarPendenciasPublicacao.fulfilled, (state, action) => {
      const atual = state.pendenciasPublicacao;
      if (atual.requestId !== action.meta.requestId) return;
      const ids = new Set(atual.items.map((item) => item.id));
      atual.items.push(...action.payload.items.filter((item) => !ids.has(item.id)));
      atual.pagination = action.payload.pagination;
      atual.loading = false;
      atual.requestId = null;
    })
    .addCase(listarPendenciasPublicacao.rejected, (state, action) => {
      const atual = state.pendenciasPublicacao;
      if (atual.requestId !== action.meta.requestId) return;
      atual.loading = false;
      atual.requestId = null;
      atual.error = action.payload ?? 'Não foi possível conferir as pendências.';
    });
}
